import {IImportService} from "./IImportService";
import {BaseService} from "./BaseService";
import {Location} from '../entities/Location'
import { StateService } from "@uirouter/angularjs";
import { ImportField } from "../models/import/ImportField";
import { ImportError } from "../models/import/ImportError";
import { ServerImportField } from "../models/serverimport/ServerImportField";
import { ImportColumn } from "../models/import/ImportColumn";

export class LocationService extends BaseService<Location> implements IImportService<Location>{
    static $inject = ['$http','$q','$state'];
    constructor($http: ng.IHttpService, $q: ng.IQService, $state: StateService) {
        super($http, $q, $state, Location);
    }
    protected getBaseUrl():string{
        return "location";
    }
    getByName(name:string):ng.IPromise<Location>{
        // Modified 022519 by BA to put name as a query parameter to handle special characters (# and %)
        return this.useBaseGetHandler(this.getBaseUrl(),"name?name="+ encodeURIComponent(name), {});
    }
    getByRfid(rfidTag:string):ng.IPromise<Location>{
        return this.useBaseGetHandler(this.getBaseUrl(),"rfidtag/"+rfidTag, {});
    }
    importFile(fileId: string, importFields: ServerImportField[], test: boolean): ng.IPromise<boolean> {
        return this.usePostHandler(this.getBasesUrl(), 'serverImport?fileId=' + fileId + '&test=' + test, importFields);
    }
    importFileProgress(fileId: string): ng.IPromise<number> {
        return this.useGetHandler(this.getBasesUrl(), "serverimportprogress?fileId=" + fileId, {});
    }
    importResults(fileId: string): ng.IPromise<ImportError[]> {
        return this.useGetHandler(this.getBasesUrl(), "serverimportresults?fileId=" + fileId, {});
    }
    getImportColumns(fileId: string): ng.IPromise<ImportColumn[]> {
        var config: any = {};
        //TODO: work on this. not implemented
        return this.useGetHandler(this.getBasesUrl(), "ImportColumns?fileId=" + fileId, config);
    }
    getImportFields():ng.IPromise<any>{
        var config:any = {};
        return this.useGetHandler(this.getBasesUrl(),"importFields", config);
    }
    getReport(search:string){
        var config:any = {
            headers: {
                'Content-type': 'application/json',
                'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            },
            responseType: 'arraybuffer'
        };
        return this.useGetHandler("Report","Locations?search="+search, config);
    }
    import(entities:Location[],test:boolean):ng.IPromise<any>{
        return this.usePostHandler(this.getBasesUrl(),"import?test="+test, entities);
    }
}
